import React from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import Chart from "react-apexcharts";
import Spinner from "../../shared/components/scrollbar/lib/spinner";
import { appHelpers } from "../../_helpers";

function formatPieChatData(apiData) {
  let labels = appHelpers.findAllByKey(apiData, "Name");
  let series = appHelpers.findAllByKey(apiData, "Count");

  return {
    labels,
    series,
  };
}

const PieChart = ({ title, pieChatData }) => {
  let formattedPieChartData;
  if (pieChatData !== null) {
    formattedPieChartData = formatPieChatData(pieChatData);
  }

  const options = {
    chart: {
      type: "pie",
    },
    colors: ["#FF3A29", "#FFB200", "#4339F2", "#31AEC9","#72CF47", ],
    labels: formattedPieChartData.labels,
  };

  return (
    <Card className="pb-3" style={{ backgroundColor: "#FBFBFB" }}>
      <CardBody>
        <CardTitle className={"text-left pb-4"}>{title}</CardTitle>
        <div
          style={{
            height: "338px",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          <div className="chart-wrapper">
            {!pieChatData ? (
              <center>
                <div>No Data</div>
              </center>
            ) : (
              <Chart
                options={options}
                series={formattedPieChartData.series}
                type="pie"
                width="400"
              />
            )}
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default PieChart;



// WEBPACK FOOTER //
// ./src/views/avicollectDashboard/pie-chart.js